module.exports = __webpack_public_path__ + "img/水杯2.38fe9501.png";